import { render, staticRenderFns } from "./Waitlisted.vue?vue&type=template&id=b8ba45da&scoped=true"
import script from "./Waitlisted.vue?vue&type=script&lang=js"
export * from "./Waitlisted.vue?vue&type=script&lang=js"
import style0 from "./Waitlisted.vue?vue&type=style&index=0&id=b8ba45da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba45da",
  null
  
)

export default component.exports